/**
 * SHIRO SPORTS 整体院 — Main JavaScript
 */

'use strict';

/* =========================================
   HEADER: scroll behaviour
   ========================================= */
(function initHeader() {
  const header = document.getElementById('site-header');
  if (!header) return;

  const onScroll = () => {
    if (window.scrollY > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll(); // run once on load
})();

/* =========================================
   HAMBURGER MENU
   ========================================= */
(function initHamburger() {
  const btn    = document.getElementById('hamburger-btn');
  const mNav   = document.getElementById('mobile-nav');
  if (!btn || !mNav) return;

  const open  = () => {
    btn.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    mNav.classList.add('open');
    mNav.setAttribute('aria-hidden', 'false');
  };
  const close = () => {
    btn.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    mNav.classList.remove('open');
    mNav.setAttribute('aria-hidden', 'true');
  };

  btn.addEventListener('click', () => {
    if (btn.classList.contains('open')) close();
    else open();
  });

  // Close when a link is clicked
  mNav.querySelectorAll('a').forEach(a => {
    a.addEventListener('click', close);
  });

  // Close on outside click
  document.addEventListener('click', (e) => {
    if (!btn.contains(e.target) && !mNav.contains(e.target)) {
      close();
    }
  });
})();

/* =========================================
   COUPON PANEL: toggle
   ========================================= */
(function initCouponPanel() {
  const toggleBtn = document.getElementById('coupon-toggle');
  const panel     = document.getElementById('coupon-panel');
  if (!toggleBtn || !panel) return;

  toggleBtn.addEventListener('click', () => {
    const isOpen = panel.classList.contains('open');

    if (isOpen) {
      panel.classList.remove('open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      panel.setAttribute('aria-hidden', 'true');
    } else {
      panel.classList.add('open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      panel.setAttribute('aria-hidden', 'false');

      // Smooth scroll into view after animation starts
      setTimeout(() => {
        panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 100);
    }
  });
})();

/* =========================================
   SCROLL REVEAL: fade-in on scroll
   ========================================= */
(function initScrollReveal() {
  const targets = document.querySelectorAll(
    '.menu-card, .coupon-section, .access-grid, .director-inner, .concept-strip'
  );

  if (!('IntersectionObserver' in window)) {
    // Fallback: just show everything
    targets.forEach(el => el.style.opacity = '1');
    return;
  }

  // Initial state
  targets.forEach(el => {
    el.style.opacity     = '0';
    el.style.transform   = 'translateY(24px)';
    el.style.transition  = 'opacity 0.65s ease, transform 0.65s ease';
  });

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity   = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  targets.forEach(el => observer.observe(el));
})();

/* =========================================
   SMOOTH SCROLL for anchor links
   ========================================= */
(function initSmoothScroll() {
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;

      e.preventDefault();
      const headerH = parseInt(
        getComputedStyle(document.documentElement)
          .getPropertyValue('--header-h') || '72',
        10
      );
      const top = target.getBoundingClientRect().top + window.scrollY - headerH - 12;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
})();

/* =========================================
   GOOGLE CALENDAR FALLBACK
   If the GCal scheduling button fails to load,
   the fallback .btn-reserve link is always visible.
   ========================================= */
(function initCalendarFallback() {
  setTimeout(() => {
    const wrapper = document.querySelector('.gcal-wrapper');
    if (!wrapper) return;
    const hasContent = wrapper.children.length > 2;
    if (!hasContent) {
      wrapper.style.display = 'none';
    }
  }, 4000);
})();

/* =========================================
   自前ボタン → 非表示GCalボタンをトリガー
   ========================================= */
(function initReservationBtn() {
  const triggerBtn = document.getElementById('btn-open-gcal');
  if (!triggerBtn) return;

  triggerBtn.addEventListener('click', function() {
    // GCalスクリプトが#gcal-anchorの中に生成したボタン/リンクを探してクリック
    const anchor = document.getElementById('gcal-anchor');
    if (anchor) {
      const gcalBtn = anchor.querySelector('a, button');
      if (gcalBtn) {
        gcalBtn.click();
        return;
      }
    }
    // フォールバック：直接URLを開く
    window.open(
      'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0BRaIvcallxQ91hAkR31Efewv3E_ZNcq64IUwR41SWRCyOlntI_5iL9biOSgXbTrgBAlX2RxcT?gv=true',
      '_blank'
    );
  });
})();

/* =========================================
   GALLERY SLIDESHOW
   ========================================= */
(function initSlideshow() {
  const slides    = document.querySelectorAll('.slide');
  const dots      = document.querySelectorAll('.slide-dot');
  const prevBtn   = document.getElementById('slide-prev');
  const nextBtn   = document.getElementById('slide-next');
  if (!slides.length) return;

  let current   = 0;
  let timer     = null;
  const INTERVAL = 4000; // 4秒で自動送り

  function goTo(index) {
    slides[current].classList.remove('active');
    dots[current].classList.remove('active');
    dots[current].setAttribute('aria-selected', 'false');

    current = (index + slides.length) % slides.length;

    slides[current].classList.add('active');
    dots[current].classList.add('active');
    dots[current].setAttribute('aria-selected', 'true');
  }

  function startAuto() {
    clearInterval(timer);
    timer = setInterval(() => goTo(current + 1), INTERVAL);
  }

  function resetAuto() {
    startAuto();
  }

  // Prev / Next
  if (prevBtn) {
    prevBtn.addEventListener('click', () => { goTo(current - 1); resetAuto(); });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', () => { goTo(current + 1); resetAuto(); });
  }

  // Dots
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      goTo(parseInt(dot.dataset.index, 10));
      resetAuto();
    });
  });

  // Touch swipe support
  let touchStartX = 0;
  const track = document.getElementById('slideshow-track');
  if (track) {
    track.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
    }, { passive: true });
    track.addEventListener('touchend', e => {
      const diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        goTo(diff > 0 ? current + 1 : current - 1);
        resetAuto();
      }
    }, { passive: true });
  }

  // Start auto-play
  startAuto();
})();